import { Backdrop, CircularProgress } from "@mui/material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useEffect, useState } from "react";

const TARGET_URL = "https://ai-chatbot.mobillor.net";

export default function AiAgent() {
  const [status, setStatus] = useState({
    ok: null,
    code: null,
    message: "idle",
  });
  const [loading, setLoading] = useState(false);

  const check = async () => {
    setLoading(true);
    setStatus({ ok: null, code: null, message: "checking..." });
    try {
      const resp = await fetch(TARGET_URL, { method: "GET", mode: "cors" });
      setStatus({
        ok: resp.ok,
        code: resp.status,
        message: resp.ok ? "reachable" : `error ${resp.status}`,
      });
    } catch (err) {
      setStatus({
        ok: false,
        code: null,
        message: err.message || "network error",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    check();
    // optional: poll every 30s while component is mounted
    const t = setInterval(check, 30000);
    return () => clearInterval(t);
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div
        style={{
          // height: "00px",
          marginTop: "30px",
        }}
      >
        <div style={{ flex: 1, border: "1px solid #ddd", marginTop: "-40px" }}>
          {loading ? (
            <Backdrop
              sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open
            >
              <CircularProgress color="inherit" />
            </Backdrop>
          ) : (
            <iframe
              title="ai-agent-frame"
              src={TARGET_URL}
              style={{ width: "100%", height: "700px", border: 0 }}
              sandbox="allow-scripts allow-forms allow-same-origin allow-popups"
            />
          )}
        </div>

        {/* <div style={{ color: "#444", fontSize: 12 }}>
          Status code: {status.code ?? "—"}
        </div> */}
      </div>
    </DashboardLayout>
  );
}
